import { get } from 'lodash';

export class ProductPasswordFormErrorModel {
  constructor() {
    this.formError = null;
    this.hasProductError = false;
    this.hasViewPasswordError = false;
    this.flattenedErrors = {
      transactionPassword: {},
      memberProducts: {},
      parent: {},
    };
    this.hasError = true;
    this.errorMessage = {
      title: 'Warning',
      body: 'Something went wrong. Please try again later.',
    };
  }

  setFormErrors(errors) {
    this.flattenedErrors.parent = get(errors, 'errors');
    this.flattenedErrors.transactionPassword = get(errors, 'children.transactionPassword.errors');
    this.flattenedErrors.memberProducts = get(errors, 'children.memberProducts.children');
  }

  clearFormErrors() {
    this.flattenedErrors = {
      transactionPassword: {},
      memberProducts: {},
      parent: {}
    };
  }

  get parent() {
    return this.flattenedErrors['parent'];
  }

  get transactionPassword() {
    return this.flattenedErrors['transactionPassword'];
  }

  get memberProducts() {
    return this.flattenedErrors['memberProducts'];
  }
}

export default ProductPasswordFormErrorModel;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/product-password-widget/model/form-error.model.js